$(document).ready(function () {
   setTimeout(function () {
      var ratingcount = $('.product_rating').html();
      $("#shopify-product-reviews .spr-summary-caption").html(ratingcount);
      var stara = $('#shopify-product-reviews').html();
      //  $("#product_star").html(stara); 
   }, 3000);
   // product page price chnage radio button

   var vprice = $('.product-price span:first-child').html();
   $(".product-form .product-form__buttons .btn_price").html(vprice);


   $('.vbox:nth-child(1) label').click(function () {
      var vprice = $('.price_1').html();
      $(".product-form .product-form__buttons .btn_price").html(vprice);
   });
   $('.vbox:nth-child(2) label').click(function () {
      var vprice = $('.price_2').html();
      $(".product-form .product-form__buttons .btn_price").html(vprice);
   });
   $('.vbox:nth-child(3) label').click(function () {
      var vprice = $('.price_3').html();
      $(".product-form .product-form__buttons .btn_price").html(vprice);
   });
   $('.vbox:nth-child(4) label').click(function () {
      var vprice = $('.price_4').html();
      $(".product-form .product-form__buttons .btn_price").html(vprice);
   });

   /* $(window).on('scroll', function () {
      if ($(window).scrollTop() >= $('.add_bag-fixed').offset().top) {
         $('.sticky_box').addClass('add_sticky');
      } else {
         $('.sticky_box').removeClass('add_sticky');
      }
   }); */

   $(".product__info-wrapper .rating").click(function () {
      $('html, body').animate({
         scrollTop: $(".template-product #MainContent .section:nth-child(2)").offset().top - 80
      }, 1500);
   });

});